import './CheckboxGroupInput.less';
import React, {useState, useEffect} from 'react';
import CheckboxInput from "../checkbox-input/CheckboxInput";


export default function CheckboxGroupInput({
    options,
    defaultValue = [],
    value: forcedValue,
    disabled,
    onChange = value => undefined,
}) {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        onChange(value);
    }, [value]);

    const onItemChange = (itemValue, checked) => {
        setValue(value => {
            if (checked) {
                return value.concat([itemValue]);
            }

            return value.filter(v => v !== itemValue);
        });
    };

    return <div className="checkbox-group-input">
        <ul>
            {
                options.items.map(option => {
                    return <li key={option.value}>
                        <CheckboxInput
                            label={option.label}
                            defaultValue={value.includes(option.value)}
                            value={forcedValue !== undefined ? forcedValue.includes(option.value) : undefined}
                            disabled={disabled}
                            onChange={checked => onItemChange(option.value, checked)}
                        />
                    </li>;
                })
            }
        </ul>
    </div>;
}
